import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import {
  AccordionDetails,
  AccordionSummary,
  Box,
  Collapse,
  Stack,
  Typography,
} from "@mui/material";
import React, { useState } from "react";
import SpheruleIco from "../../../../../assets/images/spherule.png";
import CommonButton from "../../../../../component/Button";
import {
  CommonGrid2,
  CustomAccordion,
  StyledFlexColumnView,
} from "../../../../common-components/StyledComponents";
import { StyledSpaceBetweenBox } from "../../../quick-match/components/StyledComponent";
import ExpandIco from "../../../../../assets/icons/ExpandIco";

function Experience() {
  const [expandedAccordion, setExpandedAccordion] = useState(null);

  const staticData = [
    {
      job_title: "Lead Product Designer",
      company: "Polymath",
      start_date: " Jan 2024 ⏤ Now",
      end_date: "Present",
      accomplishments_summary:
        "Eye waste points buy-in break after let's spaces just. Uat driver's goto good keep. Vendor underlying office well busy contribution re-inventing version. Other could social fruit goalposts important nor proceduralize agile synergy.",
      accomplishments: [
        "Understanding business requirements and designing solutions. Develop architecture and design documents based on the design considerations.",
        "Design n-Tier OO system architectures using Java17 technologies+",
        "Implement solutions focusing on industry standards and operational scope.",
        "Provide technical guidance and support development of systems.",
        "Designed dynamic and multi-browser compatible pages using HTML5, CSS3, jQuery3.",
      ],
    },
    // {
    //   job_title: "Gap",
    //   start_date: "Feb 2018",
    //   end_date: "Dec 2019",
    // },
    {
      job_title: "Product Designer",
      company: "Product Designer · Spherule ·",
      start_date: "Jan 2022 -- ",
      end_date: "Jan 2024",
      accomplishments_summary:
        "Designed and implemented an e-commerce platform, developed interactive user interfaces, set up CI/CD pipelines, and utilized AWS for database migrations.",
      accomplishments: [
        "Eye waste points buy-in break after let's spaces just. Uat driver's goto good keep. Vendor underlying office well busy contribution re-inventing version. Other could social fruit goalposts important nor proceduralize agile synergy.",
      ],
    },
    {
      job_title: "Product Designer",
      company: "Product Designer · Lightbox · ",
      start_date: "Apr 2022 ",
      end_date: "⏤ Jan 2022 ",
      accomplishments_summary:
        "Eye waste points buy-in break after let's spaces just. Uat driver's goto good keep. Vendor underlying office well busy contribution re-inventing version. Other could social fruit goalposts important nor proceduralize agile synergy.",
      accomplishments: [
        "Eye waste points buy-in break after let's spaces just. Uat driver's goto good keep. Vendor underlying office well busy contribution re-inventing version. Other could social fruit goalposts important nor proceduralize agile synergy.",
      ],
    },
  ];

  const handleAccordionToggle = (index) => {
    setExpandedAccordion(expandedAccordion === index ? null : index);
  };

  return (
    <Box>
      {staticData.map((item, index) => (
        <CommonGrid2
          key={index}
          sx={{
            padding: "10px",
            mb: "1rem",
            boxShadow: "0px 1px 2px 0px rgba(16, 24, 40, 0.05)",
            borderRadius: "12px",
            backgroundColor:
              item.job_title === "Gap" ? "rgb(243, 233, 255)" : "white",
            border:
              expandedAccordion === index
                ? "2px solid #7F56D9 !important"
                : "1px solid #EAECF0 !important",
          }}
        >
          <CommonGrid2 size={12}>
            <StyledSpaceBetweenBox width={"100%"}>
              <div>
                <Stack direction="row" alignItems="center" spacing={2}>
                  <img
                    src={SpheruleIco}
                    width={"48px"}
                    height={"48px"}
                    alt="logo"
                  />
                  <StyledFlexColumnView gap={"4px"}>
                    <Typography fontSize={"16px"} fontWeight={600}>
                      {item.job_title}
                    </Typography>
                    <Typography
                      fontSize={"14px"}
                      fontWeight={400}
                      color={"#475467"}
                    >
                      {item.job_title === "Gap"
                        ? `${item.start_date || ""}${
                            item.end_date ? ` - ${item.end_date}` : ""
                          }`
                        : `${item.company || ""}${
                            item.company && item.start_date ? " · " : ""
                          }${item.start_date || ""}${
                            item.end_date ? ` - ${item.end_date}` : ""
                          }`}
                    </Typography>
                  </StyledFlexColumnView>
                </Stack>
              </div>
              {item.job_title !== "Gap" && (
                <CommonButton
                  value={
                    expandedAccordion === index
                      ? "Less Experience"
                      : "View Experience"
                  }
                  endIcon={
                    expandedAccordion === index ? (
                      <KeyboardArrowUpIcon />
                    ) : (
                      <KeyboardArrowDownIcon />
                    )
                  }
                  variant={
                    expandedAccordion === index ? "contained" : "outlined"
                  }
                  padding={"10px 14px"}
                  background={expandedAccordion === index && "#7F56D9"}
                  color={expandedAccordion === index ? "#fff" : "#344054"}
                  border={expandedAccordion !== index && "#D0D5DD"}
                  fontWeight={600}
                  fontSize="13px"
                  gap={"0px"}
                  onClick={() => handleAccordionToggle(index)}
                  minWidth={"auto"}
                />
              )}
            </StyledSpaceBetweenBox>
          </CommonGrid2>
          {/* <Collapse
            in={expandedAccordion === index}
            timeout="auto"
            unmountOnExit
          >
            <CommonGrid2 size={12} marginTop={"1.5rem"}>
              <Typography variant="p" fontFamily={"Inter"}>
                {item.accomplishments_summary}
              </Typography>
              <CustomAccordion ContentMargin={"0px"}>
                <AccordionSummary
                  expandIcon={<ExpandIco />}
                  aria-controls={`panel-content`}
                  id={`panel-header`}
                  onClick={(e) => {
                    if (!e.target.closest(".expand-icon")) {
                      e.stopPropagation();
                    }
                  }}
                  style={{ pointerEvents: "none" }}
                >
                  <Typography variant="h4" margin={"0px"} fontWeight={600}>
                    {"Accomplishments"}
                  </Typography>
                </AccordionSummary>
                <AccordionDetails padding="0px">
                  <ul
                    style={{ margin: "-0.5rem 0px 0px", fontFamily: "Inter" }}
                  >
                    {item.accomplishments?.map((data, i) => (
                      <li key={i}>{data}</li>
                    ))}
                  </ul>
                </AccordionDetails>
              </CustomAccordion>
            </CommonGrid2>
          </Collapse> */}
        </CommonGrid2>
      ))}
    </Box>
  );
}

export default Experience;
